import type { CSSProperties } from 'react'
import { cn } from '../lib/utils'

interface MenuButtonProps {
	src: string
	alt: string
	onClick: VoidFunction
	title: string
	style?: CSSProperties
	className?: string
}

const MenuButton = ({ src, alt, onClick, title, style, className }: MenuButtonProps) => {
	return (
		<button
			type="button"
			className={cn(`cursor-pointer transition-all duration-300 hover:scale-105`, className)}
			style={style}
			onClick={onClick}
			title={title}
		>
			<img
				src={src}
				alt={alt}
				className="h-full w-full object-contain transition-all duration-200 hover:brightness-110"
			/>
		</button>
	)
}

export default MenuButton
